'use client'

import { useTranslations } from 'next-intl'
import { Days, IOpeningHour } from '@/api/restaurants/types/restaurant-types'
import { parseDayOfWeek } from '@/features/restaurants/utils/parse-day-of-week'
import { parseReadableDay } from '@/features/restaurants/utils/parse-readable-day'
import { parseReadableDayOpeningHours } from '@/features/restaurants/utils/parse-readable-day-opening-hours'
import { cn } from '@/utils/styles/cn'

interface IRestaurantDetailOpeningHoursListProps {
    getDayOpeningHours: (dayNumber: number) => IOpeningHour[] | null | undefined
    className?: string
}

export const RestaurantDetailOpeningHoursList = ({
    getDayOpeningHours,
    className,
}: IRestaurantDetailOpeningHoursListProps) => {
    const t = useTranslations()

    return (
        <div className={cn('w-full flex flex-row', className)}>
            <div className="gap-y-0.5 md:gap-y-1 flex flex-col">
                {Object.values(Days).map((day, index) => {
                    const todayDay = parseDayOfWeek(new Date().getDay())

                    const isToday = todayDay === day

                    return (
                        <div
                            key={index + 'restaurant-detail-opening-hours' + 'left'}
                            className="text-left font-bold text-[14px] md:text-[16px] w-fit"
                            style={{ fontWeight: isToday ? 600 : 'normal' }}
                        >
                            {parseReadableDay(day, t)}
                        </div>
                    )
                })}
            </div>

            <div className="gap-y-0.5 md:gap-y-1 flex flex-col">
                {Object.values(Days).map((day, index) => {
                    const dayOpeningHours = getDayOpeningHours(index + 1)

                    const readableDayOpeningHours = parseReadableDayOpeningHours(
                        dayOpeningHours ?? null,
                        t
                    )

                    const todayDay = parseDayOfWeek(new Date().getDay())

                    const isToday = todayDay === day

                    return (
                        <p
                            key={index + 'restaurant-detail-opening-hours' + 'right'}
                            className="font-regular text-[14px] md:text-[16px] whitespace-nowrap relative bottom-[-0.5px] w-fit"
                            style={{ fontWeight: isToday ? 600 : 'normal' }}
                        >
                            {readableDayOpeningHours}
                        </p>
                    )
                })}
            </div>
        </div>
    )
}
